// 最近見た商品
class CMRecentlyViewed {
  static initialized = false;
  constructor() {
    if (CMRecentlyViewed.initialized) return;
    CMRecentlyViewed.initialized = true;
    this.stock_limit = 10;
    this.storage_key = 'recently_viewed';
    this.containers = document.querySelectorAll('.cm-recently-viewed__inner');
    this.initRecentlyViewed();
    if (location.pathname.includes('/products/')) {
      this.addProduct(location.pathname.split('/').pop());
    }
  }

  initRecentlyViewed() {
    if (!this.containers.length) return;
    this.containers.forEach(async container => {
      const parent_section = container.closest('.cm-recently-viewed');
      const max_products = parent_section ? parent_section.dataset.maxProducts || 10 : 10;
      const recently_viewed_data = this.getProducts();
      const slide_list = container.querySelector('.splide__list');
      const loading_element = parent_section ? parent_section.querySelector('.cm-recently-viewed__loading') : null;

      // 閲覧履歴がない場合はセクションを非表示
      if (!recently_viewed_data.length) {
        if (parent_section) parent_section.classList.add('is-hidden');
        return;
      }

      // ローディングテキストを表示
      if (loading_element) loading_element.classList.add('is-visible');

      // 表示対象のハンドルを制限
      const target_handles = recently_viewed_data.slice(0, max_products);

      // Promise.allで全商品データを並列取得
      const fetch_results = await Promise.all(
        target_handles.map(async (handle) => {
          try {
            const response = await fetch(`/products/${handle}?view=card`);
            const html_text = await response.text();
            if (!html_text.match('product-card-wrapper')) return null;
            if (html_text.match('404')) return null;
            return html_text;
          } catch (error) {
            console.warn(`商品データの取得に失敗: ${handle}`, error);
            return null;
          }
        })
      );

      // 取得結果をDOMに追加（順序を維持）
      let has_products = false;
      fetch_results.forEach(html_text => {
        if (!html_text) return;
        const slide_item = document.createElement('li');
        slide_item.className = 'splide__slide';
        slide_item.innerHTML = html_text;
        slide_list.appendChild(slide_item);
        has_products = true;
      });

      // ローディングテキストを非表示
      if (loading_element) loading_element.classList.remove('is-visible');

      // 商品がない場合はセクションを非表示
      if (!has_products) {
        if (parent_section) parent_section.classList.add('is-hidden');
        return;
      }

      // セクション設定をdata属性から取得
      const per_page_pc = parseInt(parent_section?.dataset?.perPagePc, 10) || 4;
      const per_page_sp = parseInt(parent_section?.dataset?.perPageSp, 10) || 2;
      const gap_hr = parseInt(parent_section?.dataset?.gapHr, 10) || 24;
      const gap_hr_mobile = parseInt(parent_section?.dataset?.gapHrMobile, 10) || 12;
      const auto_width_pc = parent_section?.dataset?.autoWidthPc === 'true';
      const auto_width_sp = parent_section?.dataset?.autoWidthSp === 'true';

      // Splideスライダーを初期化
      const splide_options = {
        type: 'slide',
        gap: gap_hr + 'px',
        pagination: false,
        arrows: true,
        breakpoints: {
          750: {
            gap: gap_hr_mobile + 'px',
          },
        },
      };

      // PC: カスタム幅がある場合はautoWidth、なければperPage
      if (auto_width_pc) {
        splide_options.autoWidth = true;
      } else {
        splide_options.perPage = per_page_pc;
      }

      // SP: カスタム幅がある場合はautoWidth、なければperPage
      if (auto_width_sp) {
        splide_options.breakpoints[750].autoWidth = true;
      } else {
        splide_options.breakpoints[750].perPage = per_page_sp;
      }

      new Splide(container, splide_options).mount();
    });
  }

  addProduct(product_id) {
    let recently_viewed = this.getProducts();
    recently_viewed = recently_viewed.filter((id) => id !== product_id);
    recently_viewed.unshift(product_id);
    recently_viewed = recently_viewed.slice(0, this.stock_limit);
    localStorage.setItem(this.storage_key, JSON.stringify(recently_viewed));
  }

  clearProducts() {
    localStorage.removeItem(this.storage_key);
  }

  getProducts() {
    return JSON.parse(localStorage.getItem(this.storage_key) || '[]');
  }
}
document.addEventListener('DOMContentLoaded', () => {
  new CMRecentlyViewed();
});
// 最近見た商品 ここまで

// ヒーロースライダー
class CMHero {
  static initialized = false;
  constructor() {
    if (CMHero.initialized) return;
    CMHero.initialized = true;
    this.hero_elements = document.querySelectorAll('.cm-hero');
    if (!this.hero_elements.length) return;

    this.initSliders();
  }

  initSliders() {
    this.hero_elements.forEach(hero_element => {
      const main = new Splide(hero_element);
      if (hero_element.nextElementSibling && hero_element.nextElementSibling.classList.contains('cm-hero__thumbnail')) {
        const thumbnails = new Splide(hero_element.nextElementSibling);
        main.sync(thumbnails);
        thumbnails.mount();
      }
      main.mount();
    });
  }
}
// ヒーロースライダー ここまで

// COMING SOONスライダー
class CMComingSoon {
  static initialized = false;
  constructor() {
    if (CMComingSoon.initialized) return;
    CMComingSoon.initialized = true;
    this.slider_elements = document.querySelectorAll('.cm-coming-soon__slider');
    if (!this.slider_elements.length) return;

    this.initSliders();
  }

  // Splideスライダーの初期化
  initSliders() {
    this.slider_elements.forEach(slider_element => {
      new Splide(slider_element).mount();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CMComingSoon();
});
// COMING SOONスライダー ここまで

// パララックスアニメーション
window.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  /**
   * パララックス移動アニメーションを適用する共通関数
   * @param {string} selector - CSSセレクタ
   * @param {Object} animation_props - GSAPアニメーションのpropsオブジェクト
   */
  function applyParallax(selector, animation_props) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      const el_image = el.querySelector('img');
      if (!el_image) return;
      gsap.to(el_image, {
        ...animation_props,
        scrollTrigger: {
          trigger: el,
          scrub: true
        }
      });
    });
  }

  // 移動系パララックス（各方向ごとにdistance計算が必要）
  document.querySelectorAll('.parallax-move-up').forEach(el => {
    let ratio = 0.075;
    if(el.dataset.ratio != null) {
      ratio = Number(el.dataset.ratio);
    }
    const scale_ratio = ratio * 2 + 1;
    const distance = el.clientHeight * ratio;
    const el_image = el.querySelector('img');
    if (!el_image) return;
    gsap.to(el_image, {
      startAt: { scale: scale_ratio, y: distance },
      y: -distance,
      scale: scale_ratio,
      scrollTrigger: { trigger: el, scrub: true }
    });
  });

  document.querySelectorAll('.parallax-move-down').forEach(el => {
    let ratio = 0.075;
    if(el.dataset.ratio != null) {
      ratio = Number(el.dataset.ratio);
    }
    const scale_ratio = ratio * 2 + 1;
    const distance = el.clientHeight * ratio;
    const el_image = el.querySelector('img');
    if (!el_image) return;
    gsap.to(el_image, {
      startAt: { scale: scale_ratio, y: -distance },
      y: distance,
      scale: scale_ratio,
      scrollTrigger: { trigger: el, scrub: true }
    });
  });

  document.querySelectorAll('.parallax-move-left').forEach(el => {
    let ratio = 0.075;
    if(el.dataset.ratio != null) {
      ratio = Number(el.dataset.ratio);
    }
    const scale_ratio = ratio * 2 + 1;
    const distance = el.clientHeight * ratio;
    const el_image = el.querySelector('img');
    if (!el_image) return;
    gsap.to(el_image, {
      startAt: { scale: scale_ratio, x: distance },
      x: -distance,
      scale: scale_ratio,
      scrollTrigger: { trigger: el, scrub: true }
    });
  });

  document.querySelectorAll('.parallax-move-right').forEach(el => {
    let ratio = 0.075;
    if(el.dataset.ratio != null) {
      ratio = Number(el.dataset.ratio);
    }
    const scale_ratio = ratio * 2 + 1;
    const distance = el.clientHeight * ratio;
    const el_image = el.querySelector('img');
    if (!el_image) return;
    gsap.to(el_image, {
      startAt: { scale: scale_ratio, x: -distance },
      x: distance,
      scale: scale_ratio,
      scrollTrigger: { trigger: el, scrub: true }
    });
  });

  // スケール系パララックス
  applyParallax('.parallax-scale-up', {
    startAt: { scale: 1 },
    scale: 1.2
  });

  applyParallax('.parallax-scale-down', {
    startAt: { scale: 1.2 },
    scale: 1
  });

  // 回転系パララックス
  applyParallax('.parallax-rotate-left', {
    startAt: { rotate: 10 },
    rotate: -10
  });

  applyParallax('.parallax-rotate-right', {
    startAt: { rotate: -10 },
    rotate: 10
  });
});
// パララックスアニメーション ここまで

// ストーリーバナー
class CMStoryBanner {
  static initialized = false;
  constructor() {
    if (CMStoryBanner.initialized) return;
    CMStoryBanner.initialized = true;
    this.story_banner_elements = document.querySelectorAll('.cm-story-banner__inner');
    if (!this.story_banner_elements.length) return;

    this.story_banner_elements.forEach(story_banner_element => {
      const progress_bar_element = story_banner_element.nextElementSibling;
      const progress_bar = new Splide(progress_bar_element, {
        "perPage": 3,
        "pagination": false,
        "arrows": false,
        "isNavigation": true,
        "speed": 1000
      });
      const story_banner = new Splide(story_banner_element);
      story_banner.sync(progress_bar);
      story_banner.mount();
      progress_bar.mount();
    });
  }
}
// ストーリーバナー ここまで

// タブブログ
class CMTabBlog {
  static initialized = false;
  constructor() {
    if (CMTabBlog.initialized) return;
    CMTabBlog.initialized = true;
    this.sliders = document.querySelectorAll('.cm-tab-blogs__carousel');
    if (this.sliders.length > 0) {
      this.sliders.forEach(elm => {
        const slider = new Splide(elm).mount();
        slider.on('destroy', () => {
          elm.querySelectorAll('.splide__slide').forEach(slider_slide => {
            slider_slide.style.width = null;
            slider_slide.style.height = null;
            slider_slide.style.marginRight = null;
          });
        });
      });
    }

    this.tab_elements = document.querySelectorAll('.cm-tab-blogs__tab');
    if (!this.tab_elements.length) return;

    this.tab_elements.forEach(tab_element => {
      tab_element.addEventListener('click', () => {
        const parent = tab_element.closest('.cm-tab-blogs');
        // 現在アクティブなタブのaria属性を更新
        const active_tab = parent.querySelector('.cm-tab-blogs__tab.is--active');
        if (active_tab) {
          active_tab.classList.remove('is--active');
          active_tab.setAttribute('aria-expanded', 'false');
        }
        tab_element.classList.add('is--active');
        tab_element.setAttribute('aria-expanded', 'true');
        // 現在アクティブなコンテンツのaria属性を更新
        const active_content = parent.querySelector('.cm-tab-blogs__content.is--active');
        if (active_content) {
          active_content.classList.remove('is--active');
          active_content.setAttribute('aria-hidden', 'true');
        }
        const target_content = parent.querySelector(`#${tab_element.getAttribute('aria-controls')}`);
        if (target_content) {
          target_content.classList.add('is--active');
          target_content.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }
}
// タブブログ ここまで

// タブコレクション
class CMTabCollection {
  static initialized = false;
  constructor() {
    if (CMTabCollection.initialized) return;
    CMTabCollection.initialized = true;

    // タブナビゲーションのSplide初期化
    this.tab_sliders = document.querySelectorAll('.cm-tab-collections__tabs.splide');
    this.tab_sliders.forEach(tab_slider => {
      new Splide(tab_slider).mount();
    });

    // 週間売上ソート対象のカルーセルを収集（Splide初期化を遅延させる）
    this.weekly_sales_carousels = new Set();
    const weekly_sales_sections = document.querySelectorAll('[data-weekly-sales-sort="true"]');
    weekly_sales_sections.forEach(section_el => {
      section_el.querySelectorAll('.cm-tab-collections__carousel').forEach(carousel => {
        this.weekly_sales_carousels.add(carousel);
      });
    });

    // コンテンツカルーセルのSplide初期化（週間売上ソート対象以外）
    this.sliders = document.querySelectorAll('.cm-tab-collections__carousel');
    if (this.sliders.length > 0) {
      this.sliders.forEach(elm => {
        // 週間売上ソート対象のカルーセルはスキップ（initWeeklySalesSortで初期化）
        if (this.weekly_sales_carousels.has(elm)) return;
        const slider = new Splide(elm).mount();
        slider.on('destroy', () => {
          elm.querySelectorAll('.splide__slide').forEach(slider_slide => {
            slider_slide.style.width = null;
            slider_slide.style.height = null;
            slider_slide.style.marginRight = null;
          });
        });
      });
    }

    this.tab_elements = document.querySelectorAll('.cm-tab-collections__tab');
    if (this.tab_elements.length) {
      this.tab_elements.forEach(tab_element => {
        tab_element.addEventListener('click', () => {
          const parent = tab_element.closest('.cm-tab-collections');
          // 現在アクティブなタブのaria属性を更新
          const active_tab = parent.querySelector('.cm-tab-collections__tab.is--active');
          if (active_tab) {
            active_tab.classList.remove('is--active');
            active_tab.setAttribute('aria-expanded', 'false');
          }
          tab_element.classList.add('is--active');
          tab_element.setAttribute('aria-expanded', 'true');
          // 現在アクティブなコンテンツのaria属性を更新
          const active_content = parent.querySelector('.cm-tab-collections__content.is--active');
          if (active_content) {
            active_content.classList.remove('is--active');
            active_content.setAttribute('aria-hidden', 'true');
          }
          const target_content = parent.querySelector(`#${tab_element.getAttribute('aria-controls')}`);
          if (target_content) {
            target_content.classList.add('is--active');
            target_content.setAttribute('aria-hidden', 'false');
          }
        });
      });
    }

    // 週間売上ソートの初期化を実行
    if (weekly_sales_sections.length > 0) {
      this.initWeeklySalesSort(weekly_sales_sections);
    }
  }

  /**
   * 週間売上データをフェッチし、上位商品のカードHTMLを動的に取得・表示する
   * 閲覧履歴セクション（CMRecentlyViewed）と同様のパターン
   * @param {NodeList} sections - data-weekly-sales-sort="true" が付いたセクション要素群
   */
  async initWeeklySalesSort(sections) {
    for (const section_el of sections) {
      const content_elements = Array.from(section_el.querySelectorAll('.cm-tab-collections__content'));
      const options = {
        limit: parseInt(section_el.dataset.limit, 10) || 8,
        show_ranking: section_el.dataset.showRanking === 'true',
        card_width_pc: parseInt(section_el.dataset.cardWidthPc, 10) || 4,
        card_width_sp: parseInt(section_el.dataset.cardWidthSp, 10) || 2,
      };

      if (content_elements.length === 0) continue;

      // 最初のタブ（表示中）を優先：並列フェッチで最速表示
      await this.loadTabContent(content_elements[0], options, true);

      // 残りのタブは並列で開始（各タブ内は順次フェッチ）
      if (content_elements.length > 1) {
        const remaining_promises = content_elements.slice(1).map(content_el =>
          this.loadTabContent(content_el, options, false)
        );
        await Promise.all(remaining_promises);
      }
    }
  }

  /**
   * 1つのタブのコンテンツを読み込み、Splideカルーセルを初期化する
   * @param {HTMLElement} content_el - .cm-tab-collections__content 要素
   * @param {Object} options - セクション設定
   * @param {boolean} parallel - trueの場合カードを並列フェッチ（最初のタブ用の高速モード）
   */
  async loadTabContent(content_el, { limit, show_ranking, card_width_pc, card_width_sp }, parallel = false) {
    const collection_url = content_el.dataset.collectionUrl;
    const filter_tag = (content_el.dataset.filterTag || '').trim();
    if (!collection_url) return;

    const carousel = content_el.querySelector('.cm-tab-collections__carousel');
    const list = carousel ? carousel.querySelector('.splide__list') : null;
    const loading_el = content_el.querySelector('.cm-tab-collections__loading');
    if (!list) return;

    try {
      // ① JSONエンドポイントから全ページ分のデータをフェッチ
      const all_products = await this.fetchAllWeeklySales(collection_url);

      // ② タグフィルタリング（設定がある場合）
      let filtered_products = all_products;
      if (filter_tag) {
        filtered_products = all_products.filter(
          p => p.tags && p.tags.includes(filter_tag)
        );
      }

      // ③ weekly_sale_count の降順でソート → 上位 limit 件を取得
      filtered_products.sort((a, b) => b.weekly_sale_count - a.weekly_sale_count);
      const top_products = filtered_products.slice(0, limit);

      if (top_products.length === 0) {
        if (loading_el) loading_el.classList.remove('is-visible');
        return;
      }

      let rank = 0;

      if (parallel) {
        // ④-A 並列フェッチ：全カードを同時に取得して一括挿入（最初のタブ用高速モード）
        const card_html_results = await Promise.all(
          top_products.map(async (product_data) => {
            try {
              const response = await fetch(`/products/${product_data.handle}?view=card`);
              const html_text = await response.text();
              if (!html_text.match('product-card-wrapper')) return null;
              if (html_text.match('404')) return null;
              return html_text;
            } catch (error) {
              console.warn(`商品カード取得失敗: ${product_data.handle}`, error);
              return null;
            }
          })
        );

        // 取得結果をソート順にDOMへ挿入
        card_html_results.forEach(html_text => {
          if (!html_text) return;
          rank++;
          list.appendChild(this.createSlideElement(html_text, rank, show_ranking));
        });



      } else {
        // ④-B 順次フェッチ：1枚ずつ取得→即時挿入（他タブ用プログレッシブモード）
        for (const product_data of top_products) {
          try {
            const response = await fetch(`/products/${product_data.handle}?view=card`);
            const html_text = await response.text();
            if (!html_text.match('product-card-wrapper')) continue;
            if (html_text.match('404')) continue;

            rank++;
            list.appendChild(this.createSlideElement(html_text, rank, show_ranking));


          } catch (error) {
            console.warn(`商品カード取得失敗: ${product_data.handle}`, error);
          }
        }


      }

      // ⑤ unscrollableクラスの計算
      if (rank <= card_width_pc) {
        carousel.classList.add('unscrollable-pc');
      }
      if (rank <= card_width_sp) {
        carousel.classList.add('unscrollable');
      }

    } catch (error) {
      console.error('週間売上ソートの初期化に失敗:', error);
      if (loading_el) loading_el.classList.remove('is-visible');
    }

    // ⑥ ローディングを非表示にしてSplideカルーセルを初期化
    if (loading_el) loading_el.classList.remove('is-visible');
    if (carousel) {
      const slider = new Splide(carousel).mount();
      slider.on('destroy', () => {
        carousel.querySelectorAll('.splide__slide').forEach(s => {
          s.style.width = null;
          s.style.height = null;
          s.style.marginRight = null;
        });
      });
    }
  }

  /**
   * 商品カードのスライド要素を生成する
   * @param {string} html_text - 商品カードのHTML文字列
   * @param {number} rank - ランキング順位
   * @param {boolean} show_ranking - ランキングラベルを表示するか
   * @returns {HTMLElement} スライド要素
   */
  createSlideElement(html_text, rank, show_ranking) {
    const slide_item = document.createElement('div');
    slide_item.className = 'cm-tab-collections__card-wrapper splide__slide';

    if (show_ranking) {
      const rank_class = rank === 1 ? 'cm-ranking-label--1st'
        : rank === 2 ? 'cm-ranking-label--2nd'
        : rank === 3 ? 'cm-ranking-label--3rd'
        : 'cm-ranking-label--default';
      slide_item.innerHTML = `
        <span class="cm-ranking-label ${rank_class}" aria-label="第${rank}位">
          <span class="cm-ranking-label__number">${rank}</span>
        </span>
      ` + html_text;
    } else {
      slide_item.innerHTML = html_text;
    }

    return slide_item;
  }

  /**
   * 指定コレクションの全商品のweekly_sale_countを取得する
   * 250件を超える場合は複数ページをフェッチしてマージする
   * @param {string} collection_url - コレクションのURL（例: /collections/skincare）
   * @returns {Promise<Array>} 商品データ配列（handle, weekly_sale_count, tags）
   */
  async fetchAllWeeklySales(collection_url) {
    let all_products = [];
    let current_page = 1;
    let total_pages = 1;

    do {
      const url = `${collection_url}?view=weekly_sales&page=${current_page}`;
      const response = await fetch(url);
      const data = await response.json();
      all_products = all_products.concat(data.products);
      total_pages = data.pagination.total_pages;
      current_page++;
    } while (current_page <= total_pages);

    return all_products;
  }
}
// タブコレクション ここまで

// カテゴリーリスト
class CMCategoryList {
  static initialized = false;
  constructor() {
    if (CMCategoryList.initialized) return;
    CMCategoryList.initialized = true;
    this.sliders = document.querySelectorAll('.cm-category-list__carousel');
    if (this.sliders.length > 0) {
      this.sliders.forEach(elm => {
        const slider = new Splide(elm).mount();
        slider.on('destroy', () => {
          elm.querySelectorAll('.splide__slide').forEach(slider_slide => {
            slider_slide.style.width = null;
            slider_slide.style.height = null;
            slider_slide.style.marginRight = null;
          });
        });
      });
    }
  }
}
// カテゴリーリスト ここまで

// カードリスト
class CMCardList {
  static initialized = false;
  constructor() {
    if (CMCardList.initialized) return;
    CMCardList.initialized = true;
    this.sliders = document.querySelectorAll('.cm-tab-cards__carousel');
    if (!this.sliders.length) return;
    this.sliders.forEach(slider => {
      new Splide(slider).mount();
    });
  }
}
// カードリスト ここまで

// FAQ
class CMFAQ {
  static initialized = false;
  constructor() {
    if (CMFAQ.initialized) return;
    CMFAQ.initialized = true;
    this.faq_buttons = document.querySelectorAll('.cm-faq__item-title');
    if (!this.faq_buttons.length) return;

    this.faq_buttons.forEach(faq_button => {
      faq_button.addEventListener('click', () => {
        const is_expanded = faq_button.getAttribute('aria-expanded') === 'true';
        faq_button.setAttribute('aria-expanded', !is_expanded);
        faq_button.nextElementSibling.setAttribute('aria-hidden', is_expanded);
      });
    });
  }
}
// FAQ ここまで